// removed by extract-text-webpack-plugin
module.exports = {"clearfix":"style__clearfix___3kl81","section-content":"style__section-content___dndLk","success-message":"style__success-message___ji0ia"};


//////////////////
// WEBPACK FOOTER
// ./components/BookingSuccess/style.scss
// module id = 1256
// module chunks = 0